var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.792 11.126h1.416v1.417H7.792v-1.417zm0-5.666h1.416v4.25H7.792V5.46zm.7-3.542a7.08 7.08 0 00-7.075 7.083 7.08 7.08 0 007.076 7.084A7.087 7.087 0 0015.583 9a7.087 7.087 0 00-7.09-7.083zm.008 12.75a5.665 5.665 0 01-5.667-5.667A5.665 5.665 0 018.5 3.335 5.665 5.665 0 0114.167 9 5.665 5.665 0 018.5 14.668z",
    fill: "#E9C547"
  })));
}
export default SvgWarningError;